import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

import Footer from '../documents/components/Footer'
import FooterPage from '../documents/components/FooterPage'
import Header from '../documents/components/Header'
import SectionTitle from '../documents/components/SectionTitle'
import SubSection from '../documents/components/SubSection'
import ActivitySection from '../documents/components/ActivitySection'

// Create styles
const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    padding: 25,
    fontSize: 12,
    textAlign: 'justify'
  },
  box: {
    border: '1px black solid',
    marginVertical: 25,
    padding: 10,
    minHeight: 150
  },
  boxTitle: {
    fontFamily: 'Helvetica-Bold',
    color: 'rgb(244 63 94)'
  },
  emptyText: {
    fontFamily: 'Helvetica-Oblique',
    textAlign: 'center',
    fontSize: 10,
    marginVertical: 25
  }
});

// Create Document Component
const ScriptDocument = ({ name, desc, expectedResults, goal, organisation, modules }: any) => {
  
  return (
    <Document
      language='fr-Fr'
      producer="scenup"
      creator="scenup"
    >
      <Page size="A4" style={styles.page}>
        <View style={{
          margin: 10,
          marginTop: 50,
          padding: 10
        }}>
          <Text style={{
            fontFamily: 'Helvetica-Bold',
            fontSize: 25,
            textTransform: "uppercase",
            color: 'rgb(107 114 128)',
            textAlign: 'center'
          }}>
            Script de la formation
          </Text>
        </View>
        <View style={{
          flex: '1 1 auto',
          justifyContent: 'center',
          alignItems: 'center',
          marginHorizontal: 25
        }}>
          <Text style={{
            fontFamily: 'Helvetica',
            fontSize: 50,
            color: 'rgb(101 163 13)'
          }}>
            {name}
          </Text>
          <Text style={{
            fontFamily: 'Helvetica-Oblique',
            fontSize: 20,
            marginTop: 15,
            color: 'rgb(107 114 128)',
          }}>
            {desc}
          </Text>
        </View>
        <Footer />
      </Page>
      <Page size="A4" style={styles.page}>
        <Header text={name} />
        <View style={{
          flex: 1,
          justifyContent: 'center',
          marginHorizontal: 25
        }}>
          <Text style={{
            fontSize: 25,
            fontFamily: 'Helvetica-Bold',
            textAlign: 'center',
            color: 'rgb(59 130 246)'
          }}>
            Informations générales
          </Text>
          <View style={{
            flexDirection: 'row',
            justifyContent: 'flex-start',
            marginTop: 15
          }}>
            <Text>
              Cette formation est dispensée par{' '}
            </Text>
            <Text style={{ fontFamily: 'Helvetica-Bold' }}>
              {organisation.name} sous le n° NDA : {organisation.nda}.
            </Text>
          </View>
          <Text>
            L'ensemble du contenu de ce document relève ainsi du droit d'auteur.
            Toute copie, reproduction, modification ou transfère de ce document sans l'accord du propriétaire est donc strictement interdit.
          </Text>
          <View style={styles.box}>
            <Text style={styles.boxTitle}>Objectif(s) : {'\n'}</Text>
            <Text>{goal}</Text>
          </View>
          <View style={styles.box}>
            <Text style={styles.boxTitle}>Résultat(s) attendu(s) : {'\n'}</Text>
            <Text>{expectedResults}</Text>
          </View>
        </View>
        <FooterPage />
      </Page>
      {
        (modules || []).map(({ id, order, name: moduleName, goal, sequences } : any) => {
          return <Page size="A4" style={styles.page} key={id}>
            <Header text={name} />
            <View style={{
              flex: 1
            }}>
              <SectionTitle
                text={moduleName}
                order={order}
                subText={goal}
              />
              {
                (!sequences || sequences.length === 0) ? <Text style={styles.emptyText}>Aucune information fournie</Text> : null
              }
              {
                (sequences || []).map(({ id: seqId, title: sequenceName, desc: sequenceGoal, order: seqOrder, activities }: any) => {
                  return (
                    <View key={seqId} style={{ marginHorizontal: 25, marginTop: 15 }}>
                      <SubSection
                        text={sequenceName}
                        order={seqOrder}
                        subText={sequenceGoal}
                      />
                      {
                        (!activities || activities.length === 0) ? <Text style={{...styles.emptyText, textAlign: 'left', marginTop: 15, marginBottom: 0 }}>Aucune activité fournie</Text> : null
                      }
                      {
                        (activities || []).map(({ id: actId, title: actName, order: actOrder, duration, description }: any) => {
                            return (
                              <ActivitySection
                                key={actId}
                                text={actName}
                                order={actOrder}
                                duration={duration}
                                subText={description}
                              />
                            )
                        })
                      }
                    </View>
                  )
                })
              }
            </View>
            <FooterPage />
          </Page>
        })
      }
    </Document>
)};

export default ScriptDocument
